// ** Routes Imports
import { isLFPSource } from '../../utility/helpers/utils';
import AccountsRoutes from './Accounts';
import AuthRoutes from './Auth';
import CollectionRoutes from './Collections';
import DashboardRoutes from './Dashboards';
import ECBARoutes from './ECBARoutes';
import ElcReportRoutes from './ElcReports';
import LFPRoutes from './LFPRoutes';
import LawyerReportRoutes from './LawyerReports';
import MiscRoutes from './Misc';
import ReferralReportRoutes from './ReferralReports';
import ReferralRoutes from './Referrals';
import SettingRoutes from './Settings';
import StatsReportRoutes from './StatsReports';
import TableListReportRoutes from './TableListReports';
import ReportsRoutes from './ReportRoutes';

// ** Document title
const TemplateTitle = 'Qase';

// ** Default Route
const DefaultRoute = (roles, sources, lastReferralId) => {
    //LRS Agent
    if (roles.find((item) => item.id === 6)) {
        return '/new_referral';
    }

    //Lawyer
    if (roles.find((item) => item.id === 3)) {
        let isLFP = isLFPSource(sources);
        if (isLFP) {
            return '/new_lfp_referrals';
        }
        return '/new_referrals';
    }

    //Client
    if (roles.find((item) => item.id === 2)) {
        if (lastReferralId) {
            return `/matters/${lastReferralId}`;
        }
        return '/profile';
    }

    //Agent
    if (roles.find((item) => item.id === 4)) {
        return '/agent_us_referrals';
    }

    return '/new_referrals';
};

// ** Merge Routes
const Routes = [
    ...AuthRoutes,
    ...AccountsRoutes,
    ...DashboardRoutes,
    ...ReferralRoutes,
    ...CollectionRoutes,
    ...TableListReportRoutes,
    ...StatsReportRoutes,
    ...ReferralReportRoutes,
    ...ElcReportRoutes,
    ...LawyerReportRoutes,
    ...MiscRoutes,
    ...ECBARoutes,
    ...LFPRoutes,
    ...SettingRoutes,
    ...ReportsRoutes,
];

export { DefaultRoute, TemplateTitle, Routes };
